import React from 'react';
import { BaseDesignRegistrationPanelProps, DesignRegistrationPanel } from 'common/components';
import {
  METAL_ROOF_PANEL_ACTION_BLOCK,
  METAL_ROOF_PANEL_STRUCTURE,
} from './metal-roof-design-panel-constants';

export const MetalRoofDesignPanel: React.FC<BaseDesignRegistrationPanelProps & { elementBlock: string }> = ({
  elementBlock,
  isConsultationFormVisible,
  onConsultationSignupBtnClick,
}) => (
  <DesignRegistrationPanel
    isConsultationFormVisible={isConsultationFormVisible}
    structure={{
      panel: {
        ...METAL_ROOF_PANEL_STRUCTURE.panel,
        actionBlock: [
          {
            ...METAL_ROOF_PANEL_ACTION_BLOCK,
            elementBlock,
            onClick: onConsultationSignupBtnClick,
          },
        ],
      },
      mobilePanel: {
        ...METAL_ROOF_PANEL_STRUCTURE.mobilePanel,
        mobileButton: {
          label: 'Записаться на консультацию',
          elementBlock,
          onClick: onConsultationSignupBtnClick,
        },
      },
    }}
  />
);
